import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { Borders, Colors, Fonts, FontWeights } from '../constants'
import { HistoryButton } from './history'

interface Props {
  className?: string
}

export function Navigation({ className }: Props) {
  return (
    <Content className={className}>
      <PageLink to="/swap">Swap</PageLink>
      <PageLink to="/deposit">Pool</PageLink>
      <PageLink to="/token">Token</PageLink>
      <HistoryButton />
    </Content>
  )
}

const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  > * {
    margin-right: 24px;

    &:last-child {
      margin-right: 0;
    }
  }

  @media (max-width: 512px) {
    justify-content: flex-end;

    > * {
      margin-right: 10px;
    }
  }
`

const PageLink = styled(NavLink)`
  padding: 0 8px;
  display: flex;
  height: 41px;
  align-items: center;
  justify-content: center;
  color: ${Colors.LightererGray};
  font-size: 13px;
  font-family: ${Fonts.Header};
  font-weight: ${FontWeights.Semibold};
  text-transform: uppercase;
  text-decoration: none;

  &.active {
    color: ${Colors.White};
    background-color: #00000020;
    border-radius: ${Borders.Radius};
  }

  &:hover {
    color: ${Colors.White};
  }
`
